<template>
  <div>
    <div id="overlay" v-if="fetchingData">
      <div class="spinner"></div>
    </div>
    <h3>Open Burn Recreational Permit Application Review</h3>
    <expanded-fieldset title="Applicant Information">
      <fieldset>
        <legend>Application Information</legend>
        <div class="row w-100">
          <div class="col">
            <base-input v-model="application.companyName"
                        label="Company Name"
                        placeholder="Company Name" disabled />
          </div>
        </div>
        <div class="row w-100">
          <div class="col">
            <base-input v-model="application.contactFirstName"
                        label="Contact First Name"
                        placeholder="Applicant Last Name" disabled />
          </div>
          <div class="col">
            <base-input v-model="application.contactLasttName"
                        label="Contact Last Name"
                        placeholder="Contact Last Name" disabled />
          </div>
          <div class="col">
            <base-input v-model="application.contactPhone"
                        label="Contact Phone"
                        type="tel"
                        mask="(###)-###-####"
                        placeholder="(xxx)-xxx-xxxx" disabled />
          </div>
        </div>
        <div class="row w-100">
          <div class="col-6">
            <base-input v-model="application.contactEmail"
                        label="Contact Email"
                        placeholder="Contact Email" disabled />
          </div>
          <div class="col-6">
            <base-input v-model="application.confirmEmail"
                        label="Confirm Contact Email"
                        placeholder="Confirm Contact Email" disabled />
          </div>
        </div>
        <div class="row w-100">
          <div class="col">
            <base-input v-model="application.address1"
                        label="Contact Address"
                        placeholder="Contact Address" disabled />
          </div>
        </div>
        <div class="row w-100">
          <div class="col">
            <base-input v-model="application.address2"
                        label="Contact Address 2"
                        placeholder="Contact Address 2" disabled />
          </div>
        </div>
        <div class="row w-100">
          <div class="col">
            <base-input v-model="application.city"
                        label="Contact City"
                        placeholder="Contact City" disabled />
          </div>
          <div class="col">
            <base-select v-model="application.state"
                         label="Contact State"
                         :options="formFieldData.states"
                         placeholder=" Contact State" disabled />
          </div>
          <div class="col">
            <base-input v-model="application.zip"
                        label="Zip Code"
                        placeholder="Contact Zip Code" disabled />
          </div>
        </div>
        <div class="row w-100">
          <div class="col">
            <base-input v-model="application.burnAddress1"
                        label="Burn Site Address"
                        placeholder="Burn Site Address" disabled />
          </div>
        </div>
        <div class="row w-100">
          <div class="col">
            <base-input v-model="application.burnAddress2"
                        label="Burn Site Address 2"
                        placeholder="Burn Site Address 2" disabled />
          </div>
        </div>
        <div class="row w-100">
          <div class="col">
            <base-input v-model="application.burnCity"
                        label="Burn Site City"
                        placeholder="Burn Site City" disabled />
          </div>
          <div class="col">
            <base-select v-model="application.burnState"
                         label="Burn Site State"
                         :options="formFieldData.states"
                         placeholder="Burn Site State" disabled />
          </div>
          <div class="col">
            <base-input v-model="application.burnZip"
                        label="Burn Site Zip Code"
                        placeholder="Burn Site Zip Code" disabled />
          </div>
        </div>
        <div class="row w-100">
          <div class="col-6">
            <base-date-picker v-model="application.dateOfBurn"
                              label="Date of Burn" disabled />
          </div>
          <div class="col-3">
            <base-input v-model="application.burnStartTime"
                        label="Start Time"
                        placeholder="Start Time" disabled />
          </div>
          <div class="col-3">
            <base-input v-model="application.burnEndTime"
                        label="End Time"
                        placeholder="End Time" disabled />
          </div>
        </div>
        <div class="row w-100">
          <div class="col-6">
            <base-input v-model="application.nameOfForestPreserve"
                        label="Name of Forest Preserve (if applicable)"
                        placeholder="Name of Forest Preserve" disabled />
          </div>
          <div class="col-6">
            <base-input v-model="application.localFireDepartment"
                        label="Local Fire Department"
                        placeholder="Local Fire Department" disabled />
          </div>
        </div>
      </fieldset>
    </expanded-fieldset>
    <expanded-fieldset title="Signature">
      <fieldset>
        <legend> Signature </legend>
        <div class="row w-100">
          <div class="col-6">
            <base-input v-model="application.signature"
                        label="Signature"
                        placeholder="Signature" disabled />
          </div>
          <div class="col-6">
            <base-input v-model="application.signatureTitle"
                        label="Title of Signer"
                        placeholder="Title" disabled />
          </div>
        </div>
        <div class="row w-100">
          <div class="col">
            <base-date-picker v-model="application.signatureDate"
                              label="Date of Signature" disabled />
          </div>
        </div>
      </fieldset>
    </expanded-fieldset>
    <div>
      <button type="button"
              class="btn btn-secondary"
              @click="cancel">
        Back
      </button>
      <button type="button"
              class="btn btn-primary"
              @click="finalize">
        Finalize
      </button>
    </div>
  </div>
</template>
<script>
import { PermitApplication, OpenBurnRecPermitApplication, OpenBurnFormData } from '@/js/FormObjects';
import { CapitalizeFilter } from '@/js/Mixins';
import cloneDeep from 'lodash/fp/cloneDeep';
import ExpandedFieldset from '@/components/ExplodedFieldset';
import BaseInput from '@/components/BaseInput';
import VAddress from '@/components/VAddress';
import BaseSelect from '@/components/BaseSelect';
import YesNo from '@/components/YesNo';
import BaseTimePicker from '@/components/BaseTimePicker';
import BaseDatePicker from '@/components/BaseDatePicker';
import BaseTextarea from '@/components/BaseTexarea';
import BaseCheckbox from '@/components/BaseCheckbox';
import BaseFileUploader from '@/components/BaseFileUploader';


import { submitOpenBurnRecApplication } from '~/js/FormFunctions';

export default {
  name: 'OpenBurnRecReview',
  components: {
    ExpandedFieldset, BaseInput, VAddress, BaseSelect, YesNo, BaseTimePicker, BaseDatePicker, BaseTextarea, BaseCheckbox, BaseFileUploader,
  },
  mixins: [CapitalizeFilter],
  data() {
    return {
      application: new OpenBurnRecPermitApplication(),
      formFieldData: new OpenBurnFormData(),
      fetchingData: false,
      haseFee: false,
    };
  },
  mounted() {
    this.application = cloneDeep(this.$store.state.application);
    // this.$store.commit('permitApplication', null)
    if (!(this.application)) {
      this.$notify('No permit application found.', 'error');
      this.$router.push({ name: 'OpenBurnLanding' });
    }
  },
  methods: {
    cancel() {
      this.$store.commit('temporaryForm', this.application);
      this.$router.push({
        name: 'OpenBurnRecreationalApplication',
        params: {
          form: this.application,
        },
      });
    },
    finalize() {
      this.fetchingData = true;
      const self = this;
      submitOpenBurnRecApplication(this.application.permitNumber)
        .then((result) => {
          self.$router.push({
            name: 'OpenBurnThankYouRec',
            params: {
              applicationNumber: self.application.permitNumber,
            },
          });
        });
    },
  },
  computed: {

  },
};
</script>
